angular
	.module 'App.Repository'
	.factory 'ProductSkuRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class ProductSkuRepository extends BaseRepository
				@resource = '/product_skus'
				@isRestricted = true

			return new ProductSkuRepository
	]
